import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Bell, FileText, Mail } from "lucide-react";
import { debug } from "../../utils";
import * as modalDataService from "./modalDataService";

function AddDeviceStep4Content({
    enableAlerting,
    enableSyslogConfigNotification,
    enableEmailNotification
}) {
    useEffect(() => {
        if (enableAlerting === undefined) {
            modalDataService.changeEnableAlerting(true);
        }
    }, [enableAlerting]);

    const notificationCards = [
        {
            key: "alerting",
            title: "Enable Alerting",
            icon: Bell,
            checked: !!enableAlerting,
            active: !!enableAlerting,
            onChange: (value) => modalDataService.changeEnableAlerting(value)
        },
        {
            key: "syslog",
            title: "Enable Syslog Notification",
            icon: FileText,
            checked: !!enableSyslogConfigNotification,
            active: !!enableSyslogConfigNotification,
            onChange: (value) => modalDataService.changeEnableSyslogConfig(value)
        },
        {
            key: "email",
            title: "Enable Email Notification",
            icon: Mail,
            checked: !!enableEmailNotification,
            active: !!enableEmailNotification,
            onChange: (value) => modalDataService.changeEnableEmailNotification(value)
        }
    ];

    return (
        <form className="oct_form oct_form-label-center pt-4 px-4 modal-v2-form modal-v2-form-step4" autoComplete="off">
            {/* <div className="oct_form-title modal-v2-title">Add Device Wizard - STEP 4: Notifications</div> */}

            <div className="modal-v2-step4-shell">
                <div className="modal-v2-step4-notifications">
                    {notificationCards.map((card) => {
                        const Icon = card.icon;

                        return (
                            <div
                                key={card.key}
                                className={`modal-v2-step4-card ${card.active ? "is-active" : ""}`}
                            >
                                <label className="modal-v2-step4-card-label">
                                    <input
                                        type="checkbox"
                                        checked={card.checked}
                                        onChange={() => card.onChange(!card.checked)}
                                    />

                                    <span className="modal-v2-step4-card-checkbox" aria-hidden="true">
                                        <span className="modal-v2-step4-card-check">✓</span>
                                    </span>

                                    <Icon className="modal-v2-step4-card-icon" size={18} />

                                    <span className="modal-v2-step4-card-title">{card.title}</span>
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </form>
    );
}

function mapStateToProps(state) {
    debug("AddDeviceStep4 mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;

    return {
        enableAlerting: addDeviceModal.enableAlerting,
        enableSyslogConfigNotification: addDeviceModal.enableSyslogConfigNotification || false,
        enableEmailNotification: addDeviceModal.enableEmailNotification || false
    };
}

export const AddDeviceStep4 = connect(mapStateToProps)(AddDeviceStep4Content);
